import { useSliderContext } from '@cian/slider';
import * as React from 'react';

import * as styles from './PaginationThumbs.css';
import { Thumb } from './components/Thumb';
import { TMedia } from '../../types';

interface IPaginationThumbsContext {
  scrollCurrentThumbIntoView(): void;
}

interface IPaginationThumbsProps {
  media: TMedia[];
  ref?: React.Ref<IPaginationThumbsContext>;
}

function PaginationThumbsComponent({ media, ref }: IPaginationThumbsProps) {
  const containerRef = React.useRef<HTMLUListElement>(null);
  const { currentSlide, scrollTo } = useSliderContext();
  const currentSlideRef = React.useRef(currentSlide);
  currentSlideRef.current = currentSlide;

  const handleThumbClick = React.useCallback(
    (m: TMedia) => {
      scrollTo(media.indexOf(m));
    },
    [media, scrollTo],
  );

  const scrollCurrentThumbIntoView = React.useCallback(() => {
    if (containerRef.current) {
      const childs = Array.from(containerRef.current.children);

      childs[currentSlideRef.current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, []);

  React.useImperativeHandle(
    ref,
    () => ({
      scrollCurrentThumbIntoView,
    }),
    [scrollCurrentThumbIntoView],
  );

  return (
    <ul ref={containerRef} className={styles['container']}>
      {media.map((m, i) => (
        <Thumb key={`media_${i}`} media={m} active={i === currentSlide} onClick={handleThumbClick} />
      ))}
    </ul>
  );
}

export const PaginationThumbs = PaginationThumbsComponent;
